module.exports = __webpack_public_path__ + "static/media/casino-02.14a49ac9.jpeg";